export function normalizeOwnBrandIds(ownBrandIds?: Array<string | null | undefined> | null): string[] {
  return Array.from(new Set((ownBrandIds ?? []).map(brandId => `${brandId ?? ''}`.trim()).filter(Boolean)))
}
